const maintenanceConstants = {
  MAINTENANCE_STATUS_REQUEST: 'MAINTENANCE_STATUS_REQUEST',
  MAINTENANCE_STATUS_SUCCESS: 'MAINTENANCE_STATUS_SUCCESS',
  MAINTENANCE_STATUS_FAILURE: 'MAINTENANCE_STATUS_FAILURE',
};

export default maintenanceConstants;
